import { ProviderType } from '@dcl/schemas';
import { WalletLinkConnector as BaseWalletLinkConnector } from '@web3-react/walletlink-connector';
import { getConfiguration } from '../configuration';
// Coinbase connector to connect a wallet with the Coinbase mobile wallet
export class WalletLinkConnector extends BaseWalletLinkConnector {
    constructor(chainId) {
        const config = getConfiguration()[ProviderType.WALLET_LINK];
        super({
            url: config.urls[chainId],
            appName: config.appName,
            supportedChainIds: [chainId]
        });
    }
}
//# sourceMappingURL=WalletLinkConnector.js.map